'use strict'

var schema = require('property-information/html')
var factory = require('./factory')

var html = factory(schema, 'div')
html.displayName = 'html'

module.exports = html



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/html.js
// module id = 194
// module chunks = 35783957827783 204390864267482 254791781388126